import React from "react";
import { DiffResult, Viewer } from "json-diff-kit";

interface DiffDisplayGridProps {
  diff: [DiffResult[], DiffResult[]] | undefined;
  versionOptions: any[];
  crossStageEnabled: boolean;
  compareStage: string;
  currentStage: string;
  isSameVersionSelected: boolean;
  diffUnchangedLinesOptions: any;
}

export const DiffDisplayGrid: React.FC<DiffDisplayGridProps> = ({
  diff,
  versionOptions,
  crossStageEnabled,
  compareStage,
  currentStage,
  isSameVersionSelected,
  diffUnchangedLinesOptions,
}) => {
  const shouldShowDiff =
    (versionOptions.length > 1 ||
      (crossStageEnabled && compareStage !== currentStage)) &&
    !isSameVersionSelected;

  if (!shouldShowDiff || !diff || !Array.isArray(diff) || diff.length !== 2) {
    return null;
  }

  try {
    return (
      <Viewer
        diff={diff}
        lineNumbers
        highlightInlineDiff
        hideUnchangedLines={diffUnchangedLinesOptions}
        inlineDiffOptions={{
          mode: "word",
          wordSeparator: " ",
        }}
        syntaxHighlight={{
          theme: "monokai",
        }}
        virtual={false}
      />
    );
  } catch (error) {
    console.error("Error rendering diff viewer:", error);
    return <div>Error displaying diff. Please try again.</div>;
  }
};
